<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button v-if="Core.Session.AuthUser.can('subscription_management_post')"  @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouvel abon. récurrent')}}</b-button>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'RecurringSubscriptionContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/commerce/abonnements-recurrents/nouvel-abonnement')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/commerce/abonnements-recurrents/nouvel-abonnement'))
                }
            }
        }
    }
</script>
